import { Injectable } from '@angular/core';
import { Observable,  of } from 'rxjs';
import { DischargeTmpl, DischargeTmplData } from '../../../interfaces/masters/discharge-tmpl';
import { DischargeTmplApi } from '../api/discharge-tmpl.api';
//import { DischargeTmplApi } from '../../api/master/discharge-tmpl.api';
//import { DischargeTmpl, DischargeTmplData } from '../../interface/master/discharge-tmpl';




@Injectable()
export class DischargeTmplService extends DischargeTmplData {

    constructor(private api: DischargeTmplApi) {
      super();
    }
  
  
    list(url: string): Observable<DischargeTmpl[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<DischargeTmpl>{
        return this.api.getById(url);
    }
  
    create(url: string, data:DischargeTmpl): Observable<DischargeTmpl[]> {
      return this.api.add(url,data);
    }
     saveCertificate(url: string, data:any): Observable<any[]> {
      return this.api.saveCertificate(url,data);
    }
  
    update(url: string, data:DischargeTmpl): Observable<DischargeTmpl> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  